export default {
	/** @route */
	'page/*action'(action) {
		dispatcher.trigger('cms:page:route', action);
	},
	/** @route */
	'search/site/*searchRoute'(searchRoute) {
		$('#page-search-site').show().siblings().hide(); // TODO: show a view here.
		dispatcher.trigger('cms:search:pages', searchRoute);
	},
};
